import _classCallCheck from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/lib/jenkins/workspace/HFM_MS_R5.04_May10-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { duplicate, hash as _hash } from '../../util';
import { DataFlowNode } from './dataflow';
/**
 * A class for flatten transform nodes
 */

export var FlattenTransformNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(FlattenTransformNode, _DataFlowNode);

  var _super = _createSuper(FlattenTransformNode);

  function FlattenTransformNode(parent, transform) {
    var _this;

    _classCallCheck(this, FlattenTransformNode);

    _this = _super.call(this, parent);
    _this.transform = transform;
    _this.transform = duplicate(transform); // duplicate to prevent side effects

    var _this$transform = _this.transform,
        flatten = _this$transform.flatten,
        _this$transform$as = _this$transform.as,
        as = _this$transform$as === void 0 ? [] : _this$transform$as;
    _this.transform.as = flatten.map(function (f, i) {
      var _a;

      return (_a = as[i]) !== null && _a !== void 0 ? _a : f;
    });
    return _this;
  }

  _createClass(FlattenTransformNode, [{
    key: "clone",
    value: function clone() {
      return new FlattenTransformNode(this.parent, duplicate(this.transform));
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set(this.transform.flatten);
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(this.transform.as);
    }
  }, {
    key: "hash",
    value: function hash() {
      return "FlattenTransform ".concat(_hash(this.transform));
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _this$transform2 = this.transform,
          fields = _this$transform2.flatten,
          as = _this$transform2.as;
      var result = {
        type: 'flatten',
        fields: fields,
        as: as
      };
      return result;
    }
  }]);

  return FlattenTransformNode;
}(DataFlowNode);